/* eslint-disable capitalized-comments */
/* eslint-disable no-undef */
/* eslint-disable complexity */
/* eslint-disable no-unused-vars */
document.addEventListener('DOMContentLoaded', initDateRange);

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initBabyDateLimits);
} else {
	initBabyDateLimits();
}

// Baby birth date: 4 calendar years back incl. current, up to 9 months ahead (expected birth)
function initBabyDateLimits() {
	const toInputDate = (date) => `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
	const min = new Date(new Date().getFullYear() - 3, 0, 1);
	const max = new Date();
	max.setMonth(max.getMonth() + 9);
	const toDisplayDate = (date) => toInputDate(date).split('-').reverse().join('/');
	const rangeMessage = `יש לבחור תאריך בין ${toDisplayDate(min)} ל-${toDisplayDate(max)}`;
	document.querySelectorAll('#babyDateRange .date-range').forEach((input) => {
		input.min = toInputDate(min);
		input.max = toInputDate(max);
		// iOS's month/year wheel ignores min/max, so clear an out-of-range pick; blur, not change, since typing a year fires change per digit
		input.addEventListener('blur', () => {
			input.setCustomValidity('');
			if (!input.validity.rangeUnderflow && !input.validity.rangeOverflow) {
				return;
			}
			input.value = '';
			input.classList.remove('date-selected');
			input.setCustomValidity(rangeMessage);
			input.reportValidity();
		});
		input.addEventListener('input', () => input.setCustomValidity(''));
	});
}

function initDateRange() {
	const placeholderMap = {
		'1': 'תאריך לידה משוער',
		'2': 'תאריך לידה משוער',
		'3': 'תאריך לידה של הילד הצעיר במשפחה',
		'4': 'תאריך לידה של הילד הצעיר במשפחה',
		'5': 'תאריך לידה של הנכד הצעיר במשפחה',
		'6': 'תאריך לידה של הנכד הצעיר במשפחה',
		'8': 'תאריך לידה של האחיין הצעיר במשפחה',
		'9': 'תאריך לידה של האחיין הצעיר במשפחה',
		'7': 'תאריך לידה של הילד הצעיר במשפחה'
	};
	const identitySelect = document.querySelector('#ShilavRegisterForm-Identity');
	const dateInput = document.querySelector('#babyDateRange .date-range');

	if (!identitySelect || !dateInput) {
		return;
	}
	identitySelect.addEventListener('change', function () {
		const placeholderText = placeholderMap[this.value];
		dateInput.value = '';
		dateInput.placeholder = placeholderText;
		dateInput.classList.remove('date-selected');
	});

	dateInput.addEventListener('input', function() {
		if(this.value) {
		  this.classList.add('date-selected');
		} else {
		  this.classList.remove('date-selected');
		}
	  });
	
	document.querySelector('#babyDateRange').addEventListener('click', function (e) {
		if (e.target === this) {
			dateInput.focus();
			try {
			  dateInput.click();
			} catch (err) {
			  console.log("Could not programmatically open date picker");
			}
		  }		
	});
}

function showDatePicker(inputElement) {
	inputElement.classList.add('date-picker-active');
	if ('showPicker' in inputElement) {
		inputElement.showPicker();
	}
	const onBlur = () => {
		setTimeout(() => {
			inputElement.classList.remove('date-picker-active');
			inputElement.removeEventListener('blur', onBlur);
		}, 150);
	};
	inputElement.addEventListener('blur', onBlur, { once: true });
}

const handleShilavRegister = async (event, addClass) => {
	event.preventDefault();
	const errorElement = document.querySelector(`.${addClass} #ShilavRegisterForm .shilav-register-error-banner.hidden`);
	const errorClass = `.${addClass} #ShilavRegisterForm .shilav-register-error-banner`;
	if (!errorElement) {
		hiddenError(errorClass);
	}
	const formElement = document.querySelector(`.${addClass} #ShilavRegisterForm`);
	const firstName = formElement.querySelector('#ShilavRegisterForm-FirstName').value;
	const lastName = formElement.querySelector('#ShilavRegisterForm-LastName').value;
	const email = formElement.querySelector('#ShilavRegisterForm-email').value;
	const phoneNumber = formElement.querySelector('#ShilavRegisterForm-Phone').value;
	const userId = formElement.querySelector('#ShilavRegisterForm-ID').value;
	const newsLetterSubscribed = formElement.querySelector('#ShilavRegisterForm-Newsletter').checked;
	const customerIdentity = formElement.querySelector('#ShilavRegisterForm-Identity').value;
	const dateRangeValue = formElement.querySelector('.ShilavRegisterForm-Identity-wrapper #datePicker').value;
	const dateRangeFormat = dateRangeValue.replace(/-/g, '');
	
	let errorType = 'somethingWrong';
	toggleLoadingBtn('shilav-register');
	grecaptcha.ready(async () => {
		try {
			const captchaToken = await grecaptcha.execute('6LfQlyAqAAAAAEoCCRS81zjJuBwkoBNghyXp4_kA', { action: 'MEMBERSHIP_REGISTER' });
			const response = await fetch(`${PROXY}/membership/member`, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({
					uuid: sessionStorage.getItem('otp-uuid'),
					firstName,
					lastName,
					phoneNumber,
					email,
					userId,
					newsLetterSubscribed,
					customerIdentity,
					dateRange: dateRangeFormat,
					captchaToken,
				}),
			});

			const data = await response.json();

			if (!response.ok || !data.success) {
				errorType = data.message;
				throw new Error(errorType);
			}
			sessionStorage.setItem('otp-uuid', data.uuid);
			if (data.phone) {
				tempDisableCodeRequest();
				openOtpLoginPopup(null, 'otp-code');
				document.querySelector('#phoneNumberId').textContent = data.phone;
				closeOtpLoginPopup('shilav-register');
			}

		} catch (error) {
			showError(errorClass, errorType);
		} finally {
			toggleLoadingBtn('shilav-register');
		}
	});
};

const handleShowShilavForm = () => {
	// openOtpLoginPopup(null, 'otp-code');
	closeOtpLoginPopup('verify-customer-id');
	// closeOtpLoginPopup('otp-code');
	openOtpLoginPopup(null, 'shilav-register');
}


